import React from 'react'

const HeadingComp = ({head1,head2,center}) => {
  return (
    <p className={`Text36Monts text-Primary max_768:text-[28px] ${center ? 'w-max' : ''}`} data-aos="zoom-in">{head1}  <span className='text-Secondary_Primary'>{head2}</span></p>
  )
}

export default HeadingComp
